export default __webpack_public_path__ + "img/priority/high.svg";